import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core";
import { styles } from "./styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from "@jll/icon";


const SearchBar = (props) => {
  const { classes, onSearchCriteriaChange } = props;
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState();

  const onChange = (event) => {
    setSearchText(event.target.value);
  };

  const onBlur = () => {
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ companyName: searchText });
    }
  };

  return (
    <div className={classes.filterContainer}>
      <TextField
        className={classes.inputBox}
        type="text"
        name="search_record"
        id="search_record"
        placeholder={t("labels.filter.searchRecords")}
        variant="outlined"
        onBlur={onBlur}
        onChange={onChange}
        value={searchText}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon className="far fa-search searchIcon" style={{ color: "#b0b1b3" }}/>
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
}

export default withStyles(styles, { withTheme: true })(SearchBar);
